import { LinearGradient } from 'expo-linear-gradient';
import type { LinearGradientProps } from 'expo-linear-gradient';
import type { FC } from 'react';
import { StyleSheet } from 'react-native';
import type { SharedValue } from 'react-native-reanimated';
import Animated, {
  interpolate,
  useAnimatedStyle
} from 'react-native-reanimated';

type ShiftConfig = {
  inputRange: number[];
  outputRange: number[];
};

type ScrollParallaxGradientProps = {
  scrollY: SharedValue<number>;
  colors: LinearGradientProps['colors'];
  locations?: LinearGradientProps['locations'];
  height?: number;
  shift?: ShiftConfig;
};

const DEFAULT_HEIGHT = 760;
const DEFAULT_LOCATIONS = [0.2, 0.72] as const;
const DEFAULT_SHIFT: ShiftConfig = {
  inputRange: [0, 240, 480],
  outputRange: [0, -230, -300]
};

export const ScrollParallaxGradient: FC<ScrollParallaxGradientProps> = ({
  scrollY,
  colors,
  locations = DEFAULT_LOCATIONS,
  height = DEFAULT_HEIGHT,
  shift = DEFAULT_SHIFT
}) => {
  const animatedStyle = useAnimatedStyle(() => {
    'worklet';
    const translateY = interpolate(
      scrollY.value,
      shift.inputRange,
      shift.outputRange,
      'clamp'
    );
    return {
      transform: [{ translateY }]
    };
  });

  return (
    <Animated.View
      style={[
        { position: 'absolute', top: 0, left: 0, right: 0, height },
        { pointerEvents: 'none' },
        animatedStyle
      ]}
    >
      <LinearGradient
        colors={colors}
        locations={locations}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );
};
